import { AppSections, UserRole } from '@/models/auth'

const APPLICATION_SECTION = 'app_section'
const USER_ROLE = 'role'

export function saveApplicationSection(section: AppSections) {
  if (section) {
    localStorage.setItem(APPLICATION_SECTION, section)
  }
}

export function getApplicationSection() {
  return localStorage.getItem(APPLICATION_SECTION) as AppSections
}

export function saveRoleToLocalStorage(role: UserRole) {
  return localStorage.setItem(USER_ROLE, role)
}

export function getRoleFromLocalStorage() {
  return localStorage.getItem(USER_ROLE) as UserRole
}
